export const UseDropdownLabel = (
  pickedItems: readonly string[] | readonly number[],
  allItems: readonly string[] | readonly number[],
  resultType: LabelType,
  comparatorFn?: ComparatorFn<any>,
) => {
  //const { loading } = useSelector<AppState, InventoryState>((state) => state.inventoryReducer);
  // if (loading) return 'All';
  if (pickedItems.length === 0) return '';
  if (pickedItems.length === allItems.length) return 'All';
  let label = '';
  switch (resultType) {
    case LabelType.Words:
      label = [...pickedItems]
        .map((item) => (item === 0 ? 'N/A' : item))
        .sort(comparatorFn)
        .toString();
      break;
    case LabelType.Numbers:
      label = `${pickedItems.length} Selected`;
      break;
    default:
      exhaustiveCheck(resultType);
  }
  label = label.replace(/,/g, ', ');
  return label;
};

export type ComparatorFn<T> = (itemA: T, itemB: T) => number;

export enum LabelType {
  Numbers,
  Words,
}

const exhaustiveCheck = (param: never) => {
  throw new Error(`Didn't expect to get here...`);
};
